import { render, staticRenderFns } from "./VerificationsCreateTemplate.vue?vue&type=template&id=39d86edd&"
import script from "./VerificationsCreateTemplate.vue?vue&type=script&lang=js&"
export * from "./VerificationsCreateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./VerificationsCreateTemplate.vue?vue&type=style&index=0&id=39d86edd&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d86edd')) {
      api.createRecord('39d86edd', component.options)
    } else {
      api.reload('39d86edd', component.options)
    }
    module.hot.accept("./VerificationsCreateTemplate.vue?vue&type=template&id=39d86edd&", function () {
      api.rerender('39d86edd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/VerificationsCreateTemplate.vue"
export default component.exports